import React from 'react'
import { css } from 'aphrodite'
import { Container, Row, Col } from 'reactstrap'

import style from './style'

import Sitemap from '../partials/Sitemap'

const sitemapHeader = [
  { url: '/', title: 'Home' },
  { url: '/advertisers', title: 'Advertisers' }
]

export const Advertisers = props => [
  <Sitemap key={0} sitemap={sitemapHeader} />,
  <section key={1} className={css(style.main.section)}>
    <Container>
      <Row>
        <Col xs='12' md='9'>
          <Row>
            <Col xs='12'>
              <h2 className={css(style.headers.h2)}>Ad Units</h2>
              <p className={css(style.paragraphs.lead)}>
                VPPGamingNetwork delivers multiple campaigns in all ad formats
                across all browsers and devices. Our networks are also monitored
                by DoubleVerify and MOAT, so your brand will be safe.
              </p>
            </Col>
          </Row>
          <Row>
            <Col xs='6' className={`d-flex align-items-center`}>
              <img src={`/images/partners/doubleverify.png`} />
            </Col>
            <Col xs='6' className={`d-flex align-items-center`}>
              <img src={`/images/partners/moat.png`} />
            </Col>
          </Row>
          <hr className={css(style.main.spacer)} />
          <Row>
            <Col>
              <h3 className={css(style.headers.h3)}>Video</h3>
              <ul className={css(style.lists.list)}>
                <li className={css(style.lists.listItem)}>Pre-Roll</li>
                <li className={css(style.lists.listItem)}>VAST/VPAID Video</li>
                <li className={css(style.lists.listItem)}>Pre-Game/In-Game</li>
              </ul>
            </Col>
            <Col>
              <h3 className={css(style.headers.h3)}>Display</h3>
              <ul className={css(style.lists.list)}>
                <li className={css(style.lists.listItem)}>
                  Leaderboard (728×90)
                </li>
                <li className={css(style.lists.listItem)}>
                  Medium Rectangle (300×250)
                </li>
                <li className={css(style.lists.listItem)}>
                  Wide Skyscraper (160×600)
                </li>
                <li className={css(style.lists.listItem)}>
                  Floating Floor Banner
                </li>
              </ul>
            </Col>
          </Row>
        </Col>
        <Col xs='12' md='3'>
          <h4 className={css(style.sidebar.h4)}>
            <strong className={css(style.sidebar.h4Bold)}>
              Advertise with us!
            </strong>
          </h4>
          <p className={css(style.sidebar.p)}>
            <em>
              Contact us for any sales inquiries at{' '}
              <a
                className={css(style.sidebar.link)}
                href={`mailto:sales@vppgamingnetwork.com`}
              >
                sales@vppgamingnetwork.com
              </a>
            </em>
          </p>
          <hr className={css(style.main.spacer)} />
        </Col>
      </Row>
    </Container>
  </section>
]

export default Advertisers



// WEBPACK FOOTER //
// ./src/components/Advertisers/index.js